/**
 * Generic equals method.
 * This should be used when comparing some unknown types.
 * Source comes from: https://github.com/sbs-discovery-sweden/dplay-nordics-web/blob/master/packages/dplay-adt/src/setoid.ts
 * @packageDocumentation
 */
export const isPrimitive = (a) => a === null ||
    a === undefined ||
    typeof a === "boolean" ||
    typeof a === "number" ||
    typeof a === "string" ||
    typeof a === "symbol";
export const isSetoid = (a) => typeof a === "object" &&
    a !== null &&
    "equals" in a &&
    typeof a.equals === "function" &&
    a.equals.length === 1;
export const isObject = (a) => typeof a === "object" && a !== null;
const equalsObject = (a, b) => {
    const aks = Object.keys(a);
    const bks = Object.keys(b);
    if (aks.length !== bks.length) {
        return false;
    }
    // Mutually recursive, disabling rule
    return aks.every((k) => equals(a[k], b[k]));
};
export const equalsArray = (a, b) => {
    if (a.length !== b.length) {
        return false;
    }
    return a.every((x, i) => equals(x, b[i]));
};
export const equals = (a, b) => {
    // Use standard JS equality if possible
    if (Object.is(a, b)) {
        return true;
    }
    else if (
    // If params are null or aren't objects, then they can't be compared (thus not equal)
    a === null ||
        b === null ||
        typeof a !== "object" ||
        typeof b !== "object") {
        return false;
    }
    else if (isSetoid(a) && isSetoid(b)) {
        // Use .equals if possible
        return a.equals(b);
    }
    else if (Array.isArray(a) && Array.isArray(b)) {
        // If params are arrays, compare on each element
        return equalsArray(a, b);
    }
    else if (isObject(a) && isObject(b)) {
        // If params are objects, compare by each key
        return equalsObject(a, b);
    }
    else {
        // Otherwise, params can't be compared
        return false;
    }
};

